// import React, { useEffect, useState } from "react";
// import { Link, useLocation, useNavigate } from "react-router-dom";
// import privateApi from "../../apis/privateApi";
// import Spinner from "../../components/Spinner/Spinner";
// import Notification from "../../components/Notification/Notification";
// import ConfirmDialog from "../../components/ConfirmDialog/ConfirmDialog";
// import "./BudgetDetail.css";

// const BudgetDetail = () => {
//     const navigate = useNavigate();
//     const location = useLocation();
//     const budgetId = location?.state?.budgetId;
//     const scope = location?.state?.scope;

//     const [budget, setBudget] = useState(null);
//     const [summary, setSummary] = useState(null);
//     const [loading, setLoading] = useState(true);
//     const [actionLoading, setActionLoading] = useState(false);
//     const [error, setError] = useState("");

//     const [notification, setNotification] = useState({ show: false, message: "", type: "info" });
//     const [confirmDialog, setConfirmDialog] = useState({ show: false, token: "", action: null, label: "" });

//     useEffect(() => {
//         const fetchBudgetDetails = async () => {
//             try {
//                 setLoading(true);
//                 const [budgetRes, summaryRes] = await Promise.all([
//                     privateApi.get(`/api/${scope}/budgets/${budgetId}`),
//                     privateApi.get(`/api/budgets/${budgetId}/lines-summary`)
//                 ]);

//                 setBudget(budgetRes.data.data);
//                 setSummary(summaryRes.data.data);

//             } catch (err) {
//                 setError(err.response?.data?.message || "Failed to load state budget.");
//             } finally {
//                 setLoading(false);
//             }
//         };

//         if (budgetId) fetchBudgetDetails();
//     }, [budgetId, scope]);

//     const showNotification = (message, type = "success") => setNotification({ show: true, message, type });
//     const closeNotification = () => setNotification(prev => ({ ...prev, show: false }));

//     // Confirm Dialog Handlers
//     const handleActionClick = (actionType) => {
//         const token = Math.random().toString(36).substring(2, 8).toUpperCase();
//         setConfirmDialog({
//             show: true,
//             token,
//             action: actionType,
//             label: actionType === "approve" ? "Approve this state budget" : "Lock this state budget"
//         });
//     };

//     const handleConfirmDialog = async (input) => {
//         if (input !== confirmDialog.token) {
//             showNotification("Confirmation code does not match.", "error");
//             return;
//         }
//         setConfirmDialog(prev => ({ ...prev, show: false }));

//         if (confirmDialog.action === "approve") await approveBudget();
//         if (confirmDialog.action === "lock") await lockBudget();
//     };

//     const handleCancelDialog = () => setConfirmDialog(prev => ({ ...prev, show: false }));

//     const approveBudget = async () => {
//         try {
//             setActionLoading(true);
//             const { data } = await privateApi.patch(`/api/${scope}/budgets/${budgetId}/approve`);
//             setBudget(data.data);

//             showNotification("State budget approved successfully.");
//         } catch (err) {
//             showNotification(err.response?.data?.message || "Failed to approve budget.", "error");
//         } finally {
//             setActionLoading(false);
//         }
//     };

//     const lockBudget = async () => {
//         try {
//             setActionLoading(true);
//             const { data } = await privateApi.patch(`/api/${scope}/budgets/${budgetId}/lock`);
//             setBudget(data.data);

//             showNotification("State budget locked successfully.");
//         } catch (err) {
//             showNotification(err.response?.data?.message || "Failed to lock budget.", "error");
//         } finally {
//             setActionLoading(false);
//         }
//     };

//     if (loading) return <Spinner loadingInfo="Loading Budget Details..." />;
//     if (error) return <p className="budget-detail-error">{error}</p>;
//     if (!budget) return <p>No budget found.</p>;

//     return (
//         <div className="budget-detail-container">

//             <Notification show={notification.show} message={notification.message} type={notification.type} onClose={closeNotification} />

//             <ConfirmDialog
//                 show={confirmDialog.show}
//                 token={confirmDialog.token}
//                 action={confirmDialog.label}
//                 onConfirm={handleConfirmDialog}
//                 onCancel={handleCancelDialog}
//             />

//             <header className="budget-detail-header">
//                 <h2>Budget Details</h2>
//             </header>

//             <div className="budget-detail-card">

//                 <div className="budget-detail-row"><span>Location:</span><strong>{budget.stateId?.name || budget.lgaId?.name || "-"}</strong></div>
//                 <div className="budget-detail-row"><span>Year:</span><strong>{budget.year}</strong></div>
//                 <div className="budget-detail-row"><span>Type:</span><strong>{budget.type}</strong></div>
//                 <div className="budget-detail-row"><span>Revision Number:</span><strong>{budget.revisionNumber}</strong></div>
//                 <div className="budget-detail-row"><span>Status:</span><strong className={`status ${budget.status}`}>{budget.status}</strong></div>
//                 <div className="budget-detail-row"><span>Remark:</span><strong>{budget.remark || "-"}</strong></div>
//                 <div className="budget-detail-row"><span>Created By:</span><strong>{budget.createdBy?.name || "-"}</strong></div>
//                 <div className="budget-detail-row"><span>Approved By:</span><strong>{budget.approvedBy?.name || "-"}</strong></div>
//                 <div className="budget-detail-row"><span>Locked By:</span><strong>{budget.lockedBy?.name || "-"}</strong></div>
//                 <div className="budget-detail-row"><span>Created At:</span><strong>{new Date(budget.createdAt).toLocaleString()}</strong></div>

//                 {budget.approvedAt && <div className="budget-detail-row"><span>Approved At:</span><strong>{new Date(budget.approvedAt).toLocaleString()}</strong></div>}
//                 {budget.lockedAt && <div className="budget-detail-row"><span>Locked At:</span><strong>{new Date(budget.lockedAt).toLocaleString()}</strong></div>}

//                 {/* Budget Summary */}
//                 {summary && (
//                     <div className="budget-detail-summary-section">
//                         <h3>Budget Lines Summary</h3>
//                         <div className="budget-detail-summary-row"><span>Total Budgeted:</span><strong>{summary.totalBudgeted?.toLocaleString()}</strong></div>
//                         <div className="budget-detail-summary-row"><span>Total Spent:</span><strong>{summary.totalSpent?.toLocaleString()}</strong></div>
//                         <div className="budget-detail-summary-row remaining"><span>Remaining Amount:</span><strong>{summary.remainingAmount?.toLocaleString()}</strong></div>
//                     </div>
//                 )}

//                 <div className="budget-detail-actions">
//                     {budget.status === "draft" && summary.count > 0 && <button className="budget-detail-btn-approve" onClick={() => handleActionClick("approve")} disabled={actionLoading}>{actionLoading ? "Processing..." : "Approve Budget"}</button>}
//                     {budget.status === "approved" && <button className="budget-detail-btn-lock" onClick={() => handleActionClick("lock")} disabled={actionLoading}>{actionLoading ? "Processing..." : "Lock Budget"}</button>}
//                     {(budget.budgetLineCount > 0 || budget.status === "locked" || budget.status === "approved") && <Link className="budget-detail-btn-lock" to={"/budget/budget-lines"} state={{ budget }}>View Budget Lines</Link>}
//                     {budget.status === "draft" && <Link className="budget-detail-btn-lock" to={"/budget-lines/create"} state={{ budget }}>Create Budget Line</Link>}
//                     <button className="budget-detail-back-btn" onClick={() => navigate(-1)}>Back</button>
//                 </div>

//             </div>

//         </div>
//     );
// };

// export default BudgetDetail;


import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import privateApi from "../../apis/privateApi";
import Spinner from "../../components/Spinner/Spinner";
import Notification from "../../components/Notification/Notification";
import ConfirmDialog from "../../components/ConfirmDialog/ConfirmDialog";
import "./BudgetDetail.css";

const BudgetDetail = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const budgetId = location?.state?.budgetId;
    const scope = location?.state?.scope;

    const [budget, setBudget] = useState(null);
    const [summary, setSummary] = useState(null);
    const [loading, setLoading] = useState(true);
    const [actionLoading, setActionLoading] = useState(false);
    const [error, setError] = useState('');

    const [notification, setNotification] = useState({ show: false, message: '', type: 'info' });
    const [confirmDialog, setConfirmDialog] = useState({ show: false, token: '', action: null, label: '' });

    useEffect(() => {
        if (!budgetId) return;
        (async () => {
            try {
                setLoading(true);
                const [budgetRes, summaryRes] = await Promise.all([
                    privateApi.get(`/api/${scope}/budgets/${budgetId}`),
                    privateApi.get(`/api/budgets/${budgetId}/lines-summary`),
                ]);
                setBudget(budgetRes.data.data);
                setSummary(summaryRes.data.data);
            } catch (err) {
                setError(err.response?.data?.message || 'Failed to load budget.');
            } finally {
                setLoading(false);
            }
        })();
    }, [budgetId, scope]);

    const showNotif = (message, type = 'success') => setNotification({ show: true, message, type });

    const handleActionClick = actionType => {
        const token = Math.random().toString(36).substring(2, 8).toUpperCase();
        setConfirmDialog({
            show: true, token, action: actionType,
            label: actionType === 'approve' ? 'Approve this budget' : 'Lock this budget',
        });
    };

    const handleConfirmDialog = async input => {
        if (input !== confirmDialog.token) { showNotif('Confirmation code does not match.', 'error'); return; }
        setConfirmDialog(prev => ({ ...prev, show: false }));
        if (confirmDialog.action === 'approve') await doApprove();
        if (confirmDialog.action === 'lock') await doLock();
    };

    const doApprove = async () => {
        try {
            setActionLoading(true);
            const { data } = await privateApi.patch(`/api/${scope}/budgets/${budgetId}/approve`);
            setBudget(data.data);
            showNotif('Budget approved successfully.');
        } catch (err) {
            showNotif(err.response?.data?.message || 'Failed to approve budget.', 'error');
        } finally { setActionLoading(false); }
    };

    const doLock = async () => {
        try {
            setActionLoading(true);
            const { data } = await privateApi.patch(`/api/${scope}/budgets/${budgetId}/lock`);
            setBudget(data.data);
            showNotif('Budget locked successfully.');
        } catch (err) {
            showNotif(err.response?.data?.message || 'Failed to lock budget.', 'error');
        } finally { setActionLoading(false); }
    };

    if (loading) return <Spinner loadingInfo="Loading Budget Details…" />;
    if (error) return (
        <div className="bgt-page-centered">
            <div className="bgt-error-box">⚠ {error}</div>
        </div>
    );
    if (!budget) return null;

    const locationName = budget.stateId?.name || budget.lgaId?.name || '—';

    const Field = ({ label, children }) => (
        <div className="bd-field">
            <span className="bd-field-label">{label}</span>
            <span className="bd-field-value">{children}</span>
        </div>
    );

    return (
        <div className="bgt-page-centered">
            <div className="bd-inner">
                <h1 className="bgt-page-title">Budget Details</h1>

                <Notification show={notification.show} message={notification.message}
                    type={notification.type} onClose={() => setNotification(p => ({ ...p, show: false }))} />

                <ConfirmDialog show={confirmDialog.show} token={confirmDialog.token}
                    action={confirmDialog.label}
                    onConfirm={handleConfirmDialog}
                    onCancel={() => setConfirmDialog(p => ({ ...p, show: false }))} />

                <div className="bd-card">
                    {/* Top header */}
                    <div className="bd-card-top">
                        <div className="bd-location">{locationName}</div>
                        <div className="bd-meta">
                            <span>{budget.year}</span>
                            <span className="bd-meta-sep">·</span>
                            <span>{budget.type}</span>
                            <span className="bd-meta-sep">·</span>
                            <span className={`bgt-status ${budget.status}`}>
                                <span className="bgt-status-dot" />
                                {budget.status}
                            </span>
                        </div>
                    </div>

                    {/* Fields */}
                    <div className="bd-fields">
                        <Field label="Revision No.">{budget.revisionNumber}</Field>
                        <Field label="Remark">{budget.remark || '—'}</Field>
                        <Field label="Created By">{budget.createdBy?.name || '—'}</Field>
                        <Field label="Approved By">{budget.approvedBy?.name || '—'}</Field>
                        <Field label="Locked By">{budget.lockedBy?.name || '—'}</Field>
                        <Field label="Created At">{new Date(budget.createdAt).toLocaleString()}</Field>
                        {budget.approvedAt && <Field label="Approved At">{new Date(budget.approvedAt).toLocaleString()}</Field>}
                        {budget.lockedAt && <Field label="Locked At">{new Date(budget.lockedAt).toLocaleString()}</Field>}
                    </div>

                    {/* Summary */}
                    {summary && (
                        <div className="bd-summary">
                            <div className="bd-summary-head">Budget Lines Summary</div>
                            <div className="bd-summary-grid">
                                <div className="bd-summary-item">
                                    <div className="bd-summary-label">Total Budgeted</div>
                                    <div className="bd-summary-value">₦{summary.totalBudgeted?.toLocaleString()}</div>
                                </div>
                                <div className="bd-summary-item">
                                    <div className="bd-summary-label">Total Spent</div>
                                    <div className="bd-summary-value spent">₦{summary.totalSpent?.toLocaleString()}</div>
                                </div>
                                <div className="bd-summary-item">
                                    <div className="bd-summary-label">Remaining</div>
                                    <div className="bd-summary-value remaining">₦{summary.remainingAmount?.toLocaleString()}</div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Actions */}
                    <div className="bd-actions">
                        <button className="bgt-btn bgt-btn-secondary" onClick={() => navigate(-1)}>← Back</button>

                        {budget.status === 'draft' && summary?.count > 0 && (
                            <button className="bgt-btn bgt-btn-primary" onClick={() => handleActionClick('approve')} disabled={actionLoading}>
                                {actionLoading ? 'Processing…' : '✓ Approve Budget'}
                            </button>
                        )}
                        {budget.status === 'approved' && (
                            <button className="bgt-btn bgt-btn-gold" onClick={() => handleActionClick('lock')} disabled={actionLoading}>
                                {actionLoading ? 'Processing…' : '🔒 Lock Budget'}
                            </button>
                        )}
                        {(budget.budgetLineCount > 0 || budget.status === 'locked' || budget.status === 'approved') && (
                            <Link className="bgt-btn bgt-btn-ghost" to="/budget/budget-lines" state={{ budget }}>
                                View Budget Lines
                            </Link>
                        )}
                        {budget.status === 'draft' && (
                            <Link className="bgt-btn bgt-btn-primary" to="/budget-lines/create" state={{ budget }}>
                                + Create Budget Line
                            </Link>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BudgetDetail;